<template>
  <div class="header fixed">
    <ul class="menu clearfix">
      <li
        v-for="item in headerMenuConfig"
        :key="item.name"
        class="fl item"
      >
        <div class="li-ctn">
          <i :class="item.icon"></i>
          <a :href="item.href"><span>{{item.name}}</span></a>
          <i class="icon-arrow"></i>
        </div>
        <div class="li-ctn-list">
          <ul>
            <li
              v-for="itemx in item.children"
              :key="itemx.name"
            ><a :href="itemx.href">{{itemx.name}}</a></li>
          </ul>
        </div>
      </li>
    </ul>
    <div
      class="fr login-info clearfix"
      style="width:auto"
    >
      <img src="~/assets/images/phone.png">
      <span class="name"> {{name}}</span>
      <a
        :href="logOutUrl"
        class="fl"
        style="color:#fff"
      >退出</a>
    </div>
    <div class="fr h-btns clearfix">
      <a href="/union/unionPromote.htm">产品介绍</a>
      <em></em>
      <a href="/union/questions/detail.htm">帮助中心</a>
    </div>
  </div>
</template>

<script>
import { getUserInfo, checkAndLogin, queryAuthority } from "@/service";
import { logOutUrl } from "@/config";
import { headerMenuConfig, headerMenuConfigEnterprise } from "./config";
import * as util from "@/utils";

export default {
  name: 'HeaderMenu',
  data() {
    return {
      name: "",
      logOutUrl: "",
      headerMenuConfig: []
    };
  },
  mounted() {
    this.headerMenuConfig = headerMenuConfig;
    checkAndLogin()
      .then(() => {
        this.logOutUrl = logOutUrl;
        getUserInfo().then(res => {
          if (util.hasKey(res, "data")){
            
            if (res.status == 0) {
              let data = res.data
              if (data.partyName) {
                this.name = data.partyName
              } else {
                //没有昵称，就拿手机号，中间用*隐藏
                this.name = data.loginId.substring(0, 3) + '******' + data.loginId.substring(9)
              }
            } else {
              // console.log('获取昵称失败！')
            }
          }
        })
      .catch(error => console.log(error));
      queryAuthority().then(res => {
        if(res.code != '1'){
          this.headerMenuConfig = headerMenuConfig;
        }else {
          this.headerMenuConfig = headerMenuConfigEnterprise;
        }
      }).catch(error => console.log(error))
    })
  }
};
</script>

<style lang="scss" scoped>
</style>